import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromOrganization from '../reducers/organization.reducer';
import {State} from '../reducers/organization.reducer';
import {Organization} from '../../../services/api/organizations/models/organization.model';

export const selectOrganizationState = createFeatureSelector<fromOrganization.State>(
  fromOrganization.organizationFeatureKey
);

export const getOrganizationRecord = createSelector(
  selectOrganizationState,
  (state: State): Organization => state.record
);

export const getOrganizationLoaded = createSelector(
  selectOrganizationState,
  (state: State): boolean => state.loaded
);

export const getOrganizationLoading = createSelector(
  selectOrganizationState,
  (state: State): boolean => state.loading
);

export const getOrganizationError = createSelector(
  selectOrganizationState,
  (state: State): unknown | null => state.error
);
